export default "__VITE_ASSET__r4DITvt4__"